<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import IconButton from '../IconButton.vue';
    import type { RolesTableColumn, RolesTableItem } from '@/js/stores/roles-table';
    import { useRoute } from 'vue-router';
    import { PermissionArea, RoleManagementPermissionFlag } from '@/js/consts/permissions';
    import { usePermissions } from '@/js/composables/usePermissions';
    import { PencilIcon, TrashIcon } from '@lucide/vue';
    const { hasPermission } = usePermissions();

    const route = useRoute();

    defineProps<{
        column: RolesTableColumn['field'];
        data: RolesTableItem;
    }>();

    defineEmits<{
        (e: 'delete', role: RolesTableItem): void;
    }>();

    const hasRoleAccess = hasPermission(
        PermissionArea.RoleManagement,
        RoleManagementPermissionFlag.Access
    );
</script>

<template>
    <div class="h-10 flex items-center">
        <template v-if="column === 'name'">
            <div>
                <p class="text-body">
                    {{ data.name }}
                </p>
            </div>
        </template>
        <template v-else-if="column === 'actions'">
            <div v-if="hasRoleAccess" class="flex gap-3 items-center pr-4">
                <IconButton
                    size="size-6"
                    area-size="size-6"
                    :tooltip="__('edit')"
                    :route="{ path: `/settings/manage-roles/${data.id}/edit`, query: route.query }"
                >
                    <PencilIcon class="size-5" />
                </IconButton>
                <IconButton
                    size="size-6"
                    area-size="size-6"
                    :tooltip="__('delete')"
                    @click="$emit('delete', data)"
                >
                    <TrashIcon class="size-5" />
                </IconButton>
            </div>
        </template>
    </div>
</template>
